export default "__VITE_ASSET__8e3ad7c7__"